<template>
  <div class="confirm-modal">
    <CustomModal :show="show"
                 size="sm"
                 @close="$emit('onClose')">
      <template #header>
        <h2 class="confirm-modal__heading">
          {{ heading }}
        </h2>
      </template>
      <div class="confirm-modal__body">
        <slot></slot>
      </div>
      <div class="confirm-modal__footer"></div>
      <template #footer>
        <div class="confirm-modal__actions">
          <button
            v-if="showConfirmButton"
            aria-label="Confirm"
            class="btn btn-accent-1"
            @click="$emit('onConfirm')">
            {{ confirmText }}
          </button>
          <button v-if="cancelText"
                  class="btn"
                  aria-label="Cancel"
                  @click="$emit('onClose')">
            {{ cancelText }}
          </button>
        </div>
      </template>
    </CustomModal>
  </div>
</template>

<script>
import CustomModal from "~/Components/CustomModal.vue";

export default {
  name: "ConfirmModal",
  components: {
    CustomModal
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    heading: {
      type: String,
      required: true
    },
    confirmText: {
      type: String,
      default: "Confirm"
    },
    cancelText: {
      type: String,
      default: "Cancel"
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style lang="less" scoped>
.confirm-modal {
  &__actions {
    margin-left: auto;
    margin-bottom: 10px;
  }
}
</style>
